import React from "react";
import "./photocaro.scss";
import { caroSlide } from "../../data/PhotoData";

function PhotoCaro() {
  return (
    <div className="photo-container" aria-hidden="true">
      <div className="photo-slider">
        <div className="slide-track">
          {caroSlide.map((item, index) => (
              <div className="p-slide" key={`${index}-${item.image}`}>
                <img
                  src={item.image}
                  height="200"
                  width="300"
                  alt=""
                  loading="lazy"
                  decoding="async"
                />
              </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PhotoCaro;
